
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { EncriptionService } from "digital-core";
import { IUserPreference } from "common";

@Injectable({
    providedIn: 'root'
})
export class UserPreferenceService { 

   public userPreference:Subject<IUserPreference> = new Subject();

    constructor(
      private encryptionService: EncriptionService
    ) {}

    

    public setUserPreferenceLocalStorage(userPreference: IUserPreference) {
        localStorage.removeItem("user_preference");
        localStorage.setItem(
            "user_preference",
            this.encryptionService.enc(JSON.stringify(userPreference))
          );
        this.userPreference.next(userPreference);
    }

    public getUserPreferenceLocalStorage(): IUserPreference {
        const userPreference: IUserPreference = JSON.parse(
            this.encryptionService.dec(localStorage.getItem("user_preference"))
          ) as IUserPreference;
          this.userPreference.next(userPreference)
          return userPreference;
    }

    public clearUserPreference(){
      localStorage.removeItem("user_preference");
    }
}
